import React from 'react';
import PropTypes from 'prop-types';

const PageHeaderTitle = props => (
  <h1 className="page-header-title mb-0 align-self-start">{props.title}</h1>
);

PageHeaderTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

export default PageHeaderTitle;
